import { createWorkflowDraft } from 'api/WorkflowsAPI';
import type { AppDispatch } from 'modules/app/components/App';
import { FolderId } from 'modules/domains/foldering';
import { JourneyConversion } from 'modules/journey/components/JourneyConversions';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { NewWorkflowForCreate, getNewWorkflowDraftData } from 'modules/workflows';
import { NEW_WORKFLOW_ID, WORKFLOW_TRIGGERS } from 'modules/workflows/constants';
import { hydrateJourneyGoalConversion } from './hydrateJourneyGoalConversion';

const displayText = {
  loading: 'Creating draft journey...',
  failure: 'Could not create draft journey',
};

export const createDraftWorkflow = async (
  name: string,
  description: string | undefined,
  destinationFolderId: FolderId,
  conversions: JourneyConversion[],
  dispatch: AppDispatch,
  isStartTileRefreshEnabled = false,
) => {
  try {
    dispatch(addPositiveToast(displayText.loading));

    const startNodeOverrides = isStartTileRefreshEnabled
      ? {
          nodeClass: WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT,
          eventName: '',
        }
      : {};

    const goals = hydrateJourneyGoalConversion(conversions?.[0]);

    // todo: make this the default start configuration in NODE_DATA_BY_TYPE
    // when StartTileRefresh is globally enabled WF-4918
    const workflow = {
      ...getNewWorkflowDraftData(null, startNodeOverrides).data.workflow,
      name,
      description,
      goals,
      workflowSimultaneousLimit: 1, // default to 1 during creation
    } as NewWorkflowForCreate;
    workflow.nodes[0].workflowId = NEW_WORKFLOW_ID;
    // @ts-expect-error
    workflow.destinationFolderId = destinationFolderId;

    const response = await createWorkflowDraft(workflow);
    const { data } = response;
    const { id, workflowType } = data?.createWorkflowDraft;
    window.location.href = `/workflows/${id}/edit?workflowType=${workflowType}`;
  } catch (e) {
    dispatch(addNegativeToastWithErrorId(displayText.failure, 'createDraftWorkflow'));
  }
};
